/*
 * Storefront analytics, order linking (apps/analytics/DESIGN.md §5). Hand-written, not generated.
 * Copies the consented `npp_vid` cookie (set by npp-analytics.js only with analytics consent and
 * no GPC/DNT) into the `_npp_vid` cart attribute, so the order carries it to the backend; clears the
 * attribute again when the cookie is gone (consent withdrawn). One request, only when they differ.
 */
(function () {
  var cfg;
  try {
    cfg = JSON.parse(document.getElementById('npp-a-cfg').textContent);
  } catch (e) {
    return;
  }
  var inCart = cfg.cartVid || '';
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  function cookieVid() {
    var m = /(?:^|; )npp_vid=([^;]*)/.exec(document.cookie);
    return m && UUID.test(m[1]) ? m[1] : '';
  }
  function sync() {
    var vid = cookieVid();
    if (vid === inCart) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var want = vid;
    fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { _npp_vid: want } }),
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (r.ok) inCart = want;
      })
      .catch(function () {});
  }
  // The tracker sets or clears the cookie once consent is known (on load, or when the banner is answered).
  window.setTimeout(sync, 2500);
  document.addEventListener('visitorConsentCollected', function () {
    window.setTimeout(sync, 200);
  });
})();
